<template>
  <v-footer
    id="kontakt"
    padless
    class="portfolio-footer"
  >
    <v-container class="py-6">
      <!-- GÓRNA SEKCJA -->
      <v-row

        justify="space-between"
      >
        <!-- LEWA STRONA: nazwisko, specjalizacja, chipy -->
        <v-col cols="12" md="6" class="mb-6">
          <div class="text-h5 font-weight-bold mb-1 portfolio-footer__name">
            Monika Moskaluniec
          </div>

          <div class="subtitle-2 portfolio-footer__subtitle mb-4">
            Architektin · BIM-gestützte Planung
          </div>

          <div class="d-flex flex-wrap">
            <v-chip
                    v-for="(tag, i) in tags"
                    :key="i"
                    class="ma-1 px-4 py-2 text-uppercase chip-soft"
                    label
                    outlined
                    pill
                  >
            <v-icon left small class="mr-2">
              {{ tag.icon }}
            </v-icon>
            {{ tag.name }}
            </v-chip>
          </div>
        </v-col>

        <!-- PRAWA STRONA: mail + LinkedIn w jednej kolumnie -->
        <v-col
          cols="12"
          md="5"
          class="title d-flex flex-column justify-end align-end mr-3"
        >
          <div class="d-flex align-center mb-3 ">
            <v-icon small class="mr-2" color="grey darken-1">
              mdi-email
            </v-icon>
            <a
              href="mailto:m.moskaluniec@gmail.com"
              class="portfolio-footer__link"
            >
              m.moskaluniec@gmail.com
            </a>
          </div>

          <div class="d-flex align-center">
            <v-icon small class="mr-2" color="grey darken-1">
              mdi-linkedin
            </v-icon>
            <a
              href="https://www.linkedin.com/in/m-moskaluniec/"
              target="_blank"
              rel="noopener"
              class="portfolio-footer__link"
            >
              LinkedIn
            </a>
          </div>
        </v-col>
      </v-row>

      <v-divider class="my-6"></v-divider>

      <!-- DOLNA SEKCJA: prawa autorskie + Impressum / Datenschutz -->
      <v-row
        align="center"
        justify="space-between"
        class="portfolio-footer__bottom"
      >
        <v-col cols="12" md="6" class="mb-2 mb-md-0">
          <div class="caption portfolio-footer__copyright">
            © {{ currentYear }} Monika Moskaluniec · m² Architekt
          </div>
        </v-col>

        <v-col
          cols="12"
          md="6"
          class="d-flex justify-start justify-md-end"
        >
          <v-btn
            text
            small
            class="portfolio-footer__nav-btn px-2"
            @click="$emit('impressum')"
          >
            Impressum
          </v-btn>
          <v-btn
            text
            small
            class="portfolio-footer__nav-btn px-2"
            @click="$emit('datenschutz')"
          >
            Datenschutzerklärung
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'PortfolioFooter',

  data () {
    return {
      currentYear: new Date().getFullYear(),
      tags: [
            { name: 'Nachhaltigkeit', icon: 'mdi-leaf-circle-outline' },
            { name: 'Umbau',          icon: 'mdi-home-heart' },
            // { name: 'Bildung',        icon: 'mdi-account-school-outline' },
            { name: 'Wohnbau',        icon: 'mdi-home-group' },
            { name: 'Bauleitung',     icon: 'mdi-hammer-wrench' },
            // { name: 'BIM',            icon: 'mdi-cube-outline' },
            { name: 'Stadtplanung',   icon: 'mdi-city-variant-outline' }
          ]
    }
  }
}
</script>

<style scoped>
/* Jasny, lekki, „architektoniczny” footer */
.portfolio-footer {
  background: linear-gradient(
    135deg,
    #f7f7f8 0%,
    #f0f1f3 35%,
    #e7eaed 100%
  );
  color: #222;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

/* Nazwisko – lekko technicznie */
.portfolio-footer__name {
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.portfolio-footer__subtitle {
  color: #555;
}

/* Chipy – delikatne, czytelne na jasnym tle */
.portfolio-chip {
  background: rgba(0, 0, 0, 0.04) !important;
  color: #333 !important;
  border-radius: 999px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  font-size: 12px;
  text-transform: none;
}

/* Linki kontaktowe */
.portfolio-footer__link {
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
  font-size: 16px;
}

.portfolio-footer__link:hover {
  color: #000;
  border-color: rgba(0, 0, 0, 0.4);
}

/* Dolny pasek */
.portfolio-footer__bottom {
  font-size: 12px;
}

.portfolio-footer__copyright {
  color: #666;
}

/* Przyciski Impressum / Datenschutz */
.portfolio-footer__nav-btn {
  text-transform: none !important;
  letter-spacing: 0.05em;
  font-size: 12px !important;
  color: #555 !important;
  min-width: 0;
}

.portfolio-footer__nav-btn:hover {
  color: #000 !important;
}

.chip-soft {
  border-color: #b0bec5;        /* delikatna ramka */
  font-weight: 500;
  letter-spacing: 0.06em;
  font-size: 0.78rem;
}

/* mała kropka-ikona jak „status” */
.chip-soft .v-icon {
  font-size: 0.6rem;
}

/* lekki efekt hover */
.chip-soft:hover {
  background-color: #eceff1;
}
</style>
